$(function () {
    $("li.slides__slide").click(function () {
      var url = $(this).data("prod-url");
console.log(url);
      if(url != ''){
        window.location.replace(url);
      }
    });
});